var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "table" },
    [
      _c(
        "div",
        { staticClass: "container" },
        [
          _c(
            "el-form",
            {
              ref: "formData",
              attrs: {
                model: _vm.formData,
                rules: _vm.rules,
                "label-position": _vm.labelPosition,
                "label-width": "150px",
                disabled: "",
              },
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("ssrManage.ssrName"),
                            prop: "ssrName",
                          },
                        },
                        [
                          _c("el-input", {
                            staticClass: "de-input",
                            attrs: { clearable: "" },
                            model: {
                              value: _vm.formData.ssrName,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "ssrName", $$v)
                              },
                              expression: "formData.ssrName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("ssrManage.ssrNo"),
                            prop: "ssrNo",
                            disabled: "",
                          },
                        },
                        [
                          _c("el-input", {
                            staticClass: "de-input",
                            attrs: { clearable: "" },
                            model: {
                              value: _vm.formData.ssrNo,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "ssrNo", $$v)
                              },
                              expression: "formData.ssrNo",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("ssrManage.category1"),
                            prop: "category1",
                          },
                        },
                        [
                          _c("el-input", {
                            staticClass: "de-input",
                            attrs: { clearable: "" },
                            model: {
                              value: _vm.formData.category1,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "category1", $$v)
                              },
                              expression: "formData.category1",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("ssrManage.category2"),
                            prop: "category2",
                          },
                        },
                        [
                          _c("el-input", {
                            staticClass: "de-input",
                            attrs: { clearable: "" },
                            model: {
                              value: _vm.formData.category2,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "category2", $$v)
                              },
                              expression: "formData.category2",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Status" } },
                        [
                          _c("el-input", {
                            staticClass: "de-input",
                            attrs: { clearable: "", disabled: "" },
                            model: {
                              value: _vm.formData.status,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "status", $$v)
                              },
                              expression: "formData.status",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("ssrManage.description") } },
                        [
                          _c("el-input", {
                            staticClass: "de-input",
                            attrs: { clearable: "" },
                            model: {
                              value: _vm.formData.status,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "status", $$v)
                              },
                              expression: "formData.status",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Creator" } },
                        [
                          _c("el-input", {
                            staticClass: "de-input",
                            attrs: { clearable: "", disabled: "" },
                            model: {
                              value: _vm.formData.createBy,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "createBy", $$v)
                              },
                              expression: "formData.createBy",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("ssrManage.marketScope"),
                            prop: "marketScope",
                          },
                        },
                        [
                          _c("el-input", {
                            staticClass: "de-input",
                            attrs: { clearable: "" },
                            model: {
                              value: _vm.formData.marketScope,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "marketScope", $$v)
                              },
                              expression: "formData.marketScope",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Create Date" } },
                        [
                          _c("el-input", {
                            staticClass: "de-input",
                            attrs: { clearable: "", disabled: "" },
                            model: {
                              value: _vm.formData.createDate,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "createDate", $$v)
                              },
                              expression: "formData.createDate",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("ssrManage.ssrObjective"),
                            prop: "ssrObjective",
                          },
                        },
                        [
                          _c("el-input", {
                            staticClass: "de-input",
                            attrs: { clearable: "" },
                            model: {
                              value: _vm.formData.ssrObjective,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "ssrObjective", $$v)
                              },
                              expression: "formData.ssrObjective",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", [
            _c("span", [_vm._v(_vm._s(_vm.$t("ssrManage.supplierList")))]),
          ]),
          _c(
            "el-table",
            {
              ref: "supplierList",
              staticStyle: { "margin-top": "15px" },
              attrs: {
                data: _vm.supplierList,
                border: "",
                "highlight-current-row": "",
              },
            },
            [
              _c("el-table-column", { attrs: { type: "selection" } }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  prop: "ssrNo",
                  label: _vm.$t("ssrManage.invitationCode"),
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  prop: "ssrName",
                  label: _vm.$t("ssrManage.supplierName"),
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  prop: "proposal",
                  label: _vm.$t("ssrManage.isSupplier"),
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  label: _vm.$t("ssrManage.contacts"),
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  label: _vm.$t("ssrManage.email"),
                },
              }),
            ],
            1
          ),
          _c("div", { staticStyle: { "margin-top": "15px" } }, [
            _vm._v(_vm._s(_vm.$t("ssrManage.scheduleTitle"))),
          ]),
          _c(
            "el-table",
            {
              ref: "scheduleList",
              staticStyle: { "margin-top": "15px" },
              attrs: {
                data: _vm.scheduleList,
                border: "",
                "highlight-current-row": "",
                "row-key": "id",
                "tree-props": { children: "children" },
                "default-expand-all": "",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  prop: "projectItem",
                  label: _vm.$t("ssrManage.projectItem"),
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", { staticStyle: { color: "red" } }, [
                          _vm._v("*"),
                        ]),
                        _vm._v(_vm._s(scope.row.projectItem) + " "),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  prop: "ssrName",
                  label: _vm.$t("ssrManage.timeline"),
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-date-picker", {
                          attrs: { type: "date" },
                          model: {
                            value: scope.row.timeline,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "timeline", $$v)
                            },
                            expression: "scope.row.timeline",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  prop: "proposal",
                  label: _vm.$t("ssrManage.remark"),
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-input", {
                          attrs: { clearable: "" },
                          model: {
                            value: scope.row.icTime,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "icTime", $$v)
                            },
                            expression: "scope.row.icTime",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.onDel },
                          },
                          [_vm._v("Delete")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.addScheduleRow(scope.row)
                              },
                            },
                          },
                          [_vm._v("Add")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { "margin-top": "15px" } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.ganttChartLoad },
                },
                [_vm._v("Gantt Chart")]
              ),
            ],
            1
          ),
          _c("div", { staticStyle: { "margin-top": "15px" } }, [
            _vm._v("Information"),
          ]),
          _c(
            "el-table",
            {
              ref: "informationList",
              staticStyle: { "margin-top": "15px" },
              attrs: {
                data: _vm.informationList,
                border: "",
                "highlight-current-row": "",
                "show-header": false,
              },
            },
            [
              _c("el-table-column", { attrs: { type: "selection" } }),
              _c("el-table-column", { attrs: { prop: "type" } }),
              _c("el-table-column", { attrs: { prop: "name" } }),
            ],
            1
          ),
          _c("div", { staticStyle: { "margin-top": "15px" } }, [
            _vm._v("Cost Breakdown"),
          ]),
          _c(
            "el-table",
            {
              ref: "costBreakdownList",
              staticStyle: { "margin-top": "15px" },
              attrs: {
                data: _vm.costBreakdownList,
                border: "",
                "highlight-current-row": "",
                "show-header": false,
              },
            },
            [
              _c("el-table-column", { attrs: { type: "index" } }),
              _c("el-table-column", {
                attrs: { prop: "type" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.type === "自定义"
                          ? _c(
                              "el-select",
                              {
                                model: {
                                  value: _vm.costBreakdown,
                                  callback: function ($$v) {
                                    _vm.costBreakdown = $$v
                                  },
                                  expression: "costBreakdown",
                                },
                              },
                              _vm._l(
                                _vm.costBreakdownOption,
                                function (item, index) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: item.type,
                                      value: item.type,
                                    },
                                  })
                                }
                              ),
                              1
                            )
                          : _c("span", [_vm._v(_vm._s(scope.row.type))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", { attrs: { prop: "name" } }, [
                _c("i", {
                  staticClass: "el-icon-top",
                  staticStyle: { "font-size": "18px" },
                }),
                _c("i", {
                  staticClass: "el-icon-bottom",
                  staticStyle: { "font-size": "18px", "padding-left": "15px" },
                }),
              ]),
              _c("el-table-column", {
                attrs: { prop: "type" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-link", { attrs: { type: "primary" } }, [
                          _vm._v("Delete"),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c("div", { staticStyle: { "margin-top": "15px" } }, [
            _vm._v("Corresponding CQS"),
          ]),
          _c(
            "el-table",
            {
              ref: "correspondingList",
              staticStyle: { "margin-top": "15px", width: "500px" },
              attrs: {
                data: _vm.correspondingList,
                border: "",
                "highlight-current-row": "",
                "show-header": false,
              },
            },
            [
              _c("el-table-column", { attrs: { type: "selection" } }),
              _c("el-table-column", { attrs: { prop: "name" } }),
              _c("el-table-column", {
                attrs: { width: "200" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-link", { attrs: { type: "primary" } }, [
                          _vm._v("Delete"),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "250px", "padding-left": "48px" },
                  attrs: { multiple: "" },
                  model: {
                    value: _vm.corresponding,
                    callback: function ($$v) {
                      _vm.corresponding = $$v
                    },
                    expression: "corresponding",
                  },
                },
                _vm._l(_vm.correspondingOption, function (item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { label: item.name, value: item.name },
                  })
                }),
                1
              ),
              _c("el-link", { attrs: { type: "primary" } }, [_vm._v("Add")]),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { "padding-top": "15px" } },
            [
              _c(
                "el-checkbox",
                {
                  model: {
                    value: _vm.checked,
                    callback: function ($$v) {
                      _vm.checked = $$v
                    },
                    expression: "checked",
                  },
                },
                [_vm._v("Product Spec")]
              ),
            ],
            1
          ),
          _c(
            "el-row",
            {
              staticStyle: { "padding-top": "15px" },
              attrs: { type: "flex", justify: "center" },
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.showIssueDialog = true
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("ssrManage.announce")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.saveCarrier("formData")
                    },
                  },
                },
                [_vm._v("Save As Draft")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.routerBack } },
                [_vm._v(_vm._s("Cancel"))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("supplier-dialog", {
        attrs: {
          "is-show": _vm.showSupplierDialog,
          "create-fun": _vm.onSupplier,
        },
        on: {
          "update:isShow": function ($event) {
            _vm.showSupplierDialog = $event
          },
          "update:is-show": function ($event) {
            _vm.showSupplierDialog = $event
          },
          hideDialog: function ($event) {
            _vm.showSupplierDialog = false
          },
        },
      }),
      _c("ssr-issue-dialog", {
        attrs: { "is-show": _vm.showIssueDialog, "create-fun": _vm.onIssue },
        on: {
          "update:isShow": function ($event) {
            _vm.showIssueDialog = $event
          },
          "update:is-show": function ($event) {
            _vm.showIssueDialog = $event
          },
          hideDialog: function ($event) {
            _vm.showIssueDialog = false
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }